import { useState } from 'react';
import { Grid, TextField, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { useStyles } from './AddSession.styles';
import { useTranslation } from 'react-i18next';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';

const maxYear = 9999;
const minMonth = 1;
const maxMonth = 12;

interface INewSessionDetails {
  handleNewSessionDetails: (arg0: string, arg1: number, arg2: number, arg3: boolean) => void;
  handleClose: () => void;
  isTrainingSession?: boolean;
}

const NewSessionDetails: React.FC<INewSessionDetails> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [type, setType] = useState<string>('');
  const [year, setYear] = useState<number>(2000);
  const [month, setMonth] = useState<number>(1);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.id) {
      case 'type':
        setType(event.target.value.trimStart());
        break;
      case 'year':
        if (event.target.value.trimStart().length) {
          const providedYear = Number(event.target.value.trimStart());
          if (providedYear > maxYear || providedYear < 0) setYear(new Date().getFullYear());
          else setYear(providedYear);
        }
        break;
      case 'month':
        const providedMonth = Number(event.target.value.trimStart());
        if (providedMonth > maxMonth || providedMonth < minMonth) setMonth(0);
        else setMonth(providedMonth);
        break;
    }
  };

  const isNextEnabled = type !== '' && !!year && !!month;

  const next = () => {
    props.handleNewSessionDetails(
      type,
      year,
      month,
      props.isTrainingSession !== undefined ? props.isTrainingSession : false,
    );
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={props.handleClose}
        open={true}
        size="md"
        title={'Nowa sesja egzaminacyjna'}
        confirmButtonLabel="Dodaj sesję"
        onConfirm={next}
        confirmButtonDisabled={!isNextEnabled}
        onCancel={props.handleClose}
        handleClose={props.handleClose}
        isHideBackdrop={true}
      >
        <Grid container justifyContent="center" alignItems="center">
          <div className={classes.numberCircleOutlineFirst}>
            <div className={classes.numbersInCirclesOutlineFirst}>
              <CheckIcon />
            </div>
          </div>
          <div className={classes.textOutline}>
            Dodaj nową sesję <br />
            egzaminacyjną
          </div>
          {!props.isTrainingSession && (
            <>
              <hr className={classes.line}></hr>
              <div className={classes.numberCircleOutlineCheck}>
                <div className={classes.numbersInCirclesOutlineCheck}>
                  <CheckIcon />
                </div>
              </div>
              <div className={classes.textOutline}>
                Import danych <br />
                sesji egzaminacyjnej
              </div>
            </>
          )}
          <hr className={classes.line}></hr>
          <div className={classes.numberCircleInline}>
            <div className={classes.numbersInCirclesInline}>{!props.isTrainingSession ? 3 : 2}</div>
          </div>
          <div className={classes.textInline}>
            Zdefiniuj nową <br />
            sesję egzaminacyjną
          </div>
        </Grid>

        <Grid container justifyContent="center" alignItems="center" className={classes.centeredContainer}>
          <Grid item xs={12}>
            <Typography>Zdefiniuj nową sesję egzaminacyjną</Typography>
          </Grid>
          <Grid item xs={12} className={classes.paddedItem}>
            <TextField
              id="type"
              label="Typ sesji"
              variant="outlined"
              fullWidth
              value={type}
              required
              onChange={handleChange}
              inputProps={{ 'aria-label': 'typ sesji' }}
            />
          </Grid>
          <Grid item xs={6} className={classes.paddedItem}>
            <TextField
              id="year"
              label="Rok"
              variant="outlined"
              fullWidth
              value={year}
              required
              onChange={handleChange}
              type="number"
              inputProps={{
                min: '1',
                max: '9999',
                'aria-label': 'rok',
              }}
            />
          </Grid>
          <Grid item xs={6} className={classes.paddedItem}>
            <TextField
              id="month"
              label="Miesiąc"
              variant="outlined"
              fullWidth
              value={month}
              required
              onChange={handleChange}
              type="number"
              inputProps={{
                min: '1',
                max: '12',
                'aria-label': 'miesiąc',
              }}
            />
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};

export default NewSessionDetails;
